import { LANGS_SUPPORTED } from "../../constants";
import { StorageKey } from "../../enums";
import { SupportedLanguage } from "../../models";
import { Log } from "../log.helpers";

class StorageHelpers {
  constructor(public storage: Storage) {}

  get keysLength(): number {
    return this.storage.length;
  }

  clear(): void {
    this.storage.clear();
  }

  getItem<T>(key: StorageKey): T | null {
    const value = this.storage.getItem(key);

    try {
      if (
        value === null ||
        LANGS_SUPPORTED.includes(value as SupportedLanguage)
      ) {
        return value as T;
      }

      return JSON.parse(value);
    } catch (e) {
      Log.info(
        `Storage value by key '${key}' is not compatible or doesn't need parsing.\n`,
      );
      return value as null;
    }
  }

  key(index: number): string | null {
    return this.storage.key(index);
  }

  removeItem(key: StorageKey): void {
    this.storage.removeItem(key);
  }

  setItem<T>(key: StorageKey, value: T | null): void {
    value = typeof value === "undefined" ? null : value;
    this.storage.setItem(key, JSON.stringify(value));
  }
}

class SessionFirstStorageHelpers {
  private session: StorageHelpers;
  private local: StorageHelpers;

  constructor(local: StorageHelpers, session: StorageHelpers) {
    this.local = local;
    this.session = session;
  }

  getItem<T>(key: StorageKey): T | null {
    return this.session.getItem(key) || this.local.getItem(key);
  }

  setItem<T>(key: StorageKey, value: T | undefined): void {
    this.session.setItem(key, value);
    this.local.setItem(key, value);
  }

  removeItem(key: StorageKey): void {
    this.session.removeItem(key);
    this.local.removeItem(key);
  }
}

export const localStorageHelpers = new StorageHelpers(localStorage);
export const sessionStorageHelpers = new StorageHelpers(sessionStorage);
export const sessionFirstStorageHelpers = new SessionFirstStorageHelpers(
  localStorageHelpers,
  sessionStorageHelpers,
);
